import React from 'react';
import './buttonStyle.css';
const OrangeButtonOutline = ({ label, onClick = () => {} }) => {
  return (
    <button onClick={onClick} className="cta-button secondary fredokaOne">
      {label}
    </button>
  );
};

export default OrangeButtonOutline;
